import { render, staticRenderFns } from "./dealItem.vue?vue&type=template&id=06b5ea8e"
import script from "./dealItem.vue?vue&type=script&lang=js"
export * from "./dealItem.vue?vue&type=script&lang=js"
import style0 from "./dealItem.vue?vue&type=style&index=0&id=06b5ea8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports